import { render, staticRenderFns } from "./addTable.vue?vue&type=template&id=31cfd524&scoped=true"
import script from "./addTable.vue?vue&type=script&lang=js"
export * from "./addTable.vue?vue&type=script&lang=js"
import style0 from "./addTable.vue?vue&type=style&index=0&id=31cfd524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cfd524",
  null
  
)

export default component.exports